<template>
  <MenuRef :iShow="showColor">
    <div class="home-index">
      <div class="content">
        <div class="main-content">
          <div class="search">
            <div class="data-history-filter-item">
              <label>开始时间：</label>
              <a-config-provider :locale="locale">
                <a-date-picker
                  :format="dateFormat"
                  style="flex: 1; width: 304px; height: 40px"
                  v-model="startDate"
                  :show-time="{ defaultValue: moment(startDate, 'HH:mm:ss') }"
                  @change="getStartDatePicker"
                />
              </a-config-provider>
            </div>
            <div class="data-history-filter-item" style="margin-left: 36px">
              <label>结束时间：</label>
              <a-config-provider :locale="locale">
                <a-date-picker
                  :format="dateFormat"
                  style="flex: 1; width: 304px; height: 40px"
                  v-model="endDate"
                  :show-time="{ defaultValue: moment(endDate, 'HH:mm:ss') }"
                  @change="getEndDatePicker"
                />
              </a-config-provider>
            </div>
            <a-radio-group
              v-model="size"
              size="large"
              style="margin-left: 36px"
              @change="changeDate"
            >
              <a-radio-button value="day"> 今日 </a-radio-button>
              <a-radio-button value="week"> 本周 </a-radio-button>
              <a-radio-button value="month"> 当月 </a-radio-button>
            </a-radio-group>
            <a-button
              class="search-btn"
              :style="{ marginLeft: '36px' }"
              @click="getDataList()"
            >
              查询
            </a-button>
          </div>
          <div class="count-content">
            <div class="count-top">
              <div class="main-content-green">
                <div class="top-word">
                  <div class="greens-icon">
                    <img
                      style="width: 32px; height: 32px"
                      :src="require('@/images/bBox-green.png')"
                    />
                  </div>
                  货量
                </div>
                <div class="count-icon">
                  <div class="green-word">
                    {{ this.formList.goodsWeight || 0 }} Kg
                  </div>
                </div>
              </div>
              <div class="main-content-green">
                <div class="top-word">
                  <div class="greens-icon">
                    <img
                      style="width: 32px; height: 32px"
                      :src="require('@/images/user-count-green.png')"
                    />
                  </div>
                  发货客户数
                </div>
                <div class="count-icon">
                  <div class="green-word">
                    {{ this.formList.userCount || 0 }} 家
                  </div>
                </div>
              </div>
              <div class="main-content-green">
                <div class="top-word">
                  <div class="greens-icon">
                    <img
                      style="width: 32px; height: 32px"
                      :src="require('@/images/billing-green.png')"
                    />
                  </div>
                  开单数
                </div>
                <div class="count-icon">
                  <div class="green-word">
                    {{ this.formList.orderCount || 0 }} 单
                  </div>
                </div>
              </div>
              <div class="main-content-green" style="margin-right: 50px">
                <div class="top-word">
                  <div class="greens-icon">
                    <img
                      style="width: 32px; height: 32px"
                      :src="require('@/images/user-add-green.png')"
                    />
                  </div>
                  新增客户
                </div>
                <div class="count-icon">
                  <div class="green-word">
                    {{ this.formList.newUserCount || 0 }} 家
                  </div>
                </div>
              </div>
            </div>
            <div class="count-bottom">
              <div class="bottom-content-orange">
                <div class="bottom-word">
                  <div class="oranges-icon">
                    <img
                      style="width: 32px; height: 32px"
                      :src="require('@/images/phone-green.png')"
                    />
                  </div>
                  电销个数
                </div>
                <div class="count-icon">
                  <div class="orange-word">
                    {{ this.formList.phoneCount || 0 }} 个
                  </div>
                </div>
              </div>
              <div class="bottom-content-orange">
                <div class="bottom-word">
                  <div class="oranges-icon">
                    <img
                      style="width: 32px; height: 32px"
                      :src="require('@/images/yue-green.png')"
                    />
                  </div>
                  邀约个数
                </div>
                <div class="count-icon">
                  <div class="orange-word">
                    {{ this.formList.inviteCount || 0 }} 个
                  </div>
                </div>
              </div>
              <div class="bottom-content-orange">
                <div class="bottom-word">
                  <div class="oranges-icon">
                    <img
                      style="width: 32px; height: 32px"
                      :src="require('@/images/chat-green.png')"
                    />
                  </div>
                  加微个数
                </div>
                <div class="count-icon">
                  <div class="orange-word">
                    {{ this.formList.wechatCount || 0 }} 个
                  </div>
                </div>
              </div>
              <div
                class="bottom-content-orange"
                style="background: unset !important; margin-right: 50px"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </MenuRef>
</template>

<script>
import moment from "moment";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import { getNewHomeIndexList } from "@/api";
import MenuRef from "./common/MenuRef.vue";
import Cookies from "js-cookie";
import rolePermissions from "./rolePermissions.js";

export default {
  components: {
    MenuRef,
  },
  data() {
    return {
      permissions: {},
      showColor: ["5"],
      size: "day",
      locale: zhCN,
      dateFormat: "YYYY-MM-DD",
      startDate: moment().startOf("D"),
      endDate: moment(),
      formList: {
        goodsWeight: "",
        userCount: "",
        orderCount: "",
        newUserCount: "",
        phoneCount: "",
        inviteCount: "",
        wechatCount: "",
      },
    };
  },
  methods: {
    moment,
    getStartDatePicker(date, dateString) {
      this.startDate = moment(dateString);
    },
    getEndDatePicker(date, dateString) {
      this.endDate = moment(dateString);
    },
    changeDate(e) {
      this.size = e.target.value;
      if (this.size == "day") {
        this.startDate = moment().startOf("D");
        this.endDate = moment().endOf("D");
      } else if (this.size == "week") {
        this.startDate = moment().startOf("W");
        this.endDate = moment().endOf("W");
      } else if (this.size == "month") {
        this.startDate = moment().startOf("M");
        this.endDate = moment().endOf("M");
      }
      this.getDataList();
    },
    async getDataList() {
      await getNewHomeIndexList({
        startTime: moment(this.startDate).format("YYYY-MM-DD"),
        endTime: moment(this.endDate).format("YYYY-MM-DD"),
      }).then((res) => {
        if (res.statusCode == 200) {
          this.formList = res.data;
        }
      });
    },
  },
  mounted() {
    let roleId = Cookies.get("roleId");
    this.permissions = rolePermissions[roleId];
    this.getDataList();
  },
};
</script>

<style lang="less">
.home-index {
  width: 100%;
  height: 100%;
  display: flex;

  .search-btn {
    background: #14cc76;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    border-color: #14cc76;
    width: 80px;
    height: 40px;
  }

  .search-btn:hover,
  .search-btn:active,
  .search-btn:focus {
    background: #14cc76;
    border-radius: 4px;
    color: #ffffff;
    border-color: #14cc76;
  }

  .search {
    margin: 24px;
    display: flex;
    align-items: center;
    height: 50px;
    .green-icon {
      width: 3px;
      height: 20px;
      background: #14cc76;
      border-radius: 2px;
      margin-right: 8px;
    }
    .word {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 20px;
      color: #313332;
      line-height: 28px;
      text-align: left;
      font-style: normal;
    }
  }

  .content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 8px;
    margin-right: 16px;

    .main-content {
      width: 100%;
      height: 45%;
      display: flex;
      flex-direction: column;

      .count-content {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        margin: 16px 24px;
        .count-top {
          width: 100%;
          display: flex;
          .main-content-green {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            width: 25%;
            height: 170px;
            background: linear-gradient(
              180deg,
              rgba(20, 204, 118, 0.02) 0%,
              rgba(20, 204, 118, 0.06) 100%
            );
            border-radius: 4px;
            margin-right: 38px;
            padding: 24px 10px 10px 24px;

            .top-word {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 18px;
              color: #313332;
              line-height: 22px;
              text-align: left;
              font-style: normal;
              margin-bottom: 20px;
              display: flex;
              align-items: center;
              .greens-icon {
                margin-right: 12px;
              }
            }

            .count-icon {
              width: 100%;
              height: 100%;
              display: flex;
              margin-top: 12px;
              .green-word {
                width: 100%;
                display: flex;
                justify-content: center;
                font-family: DINAlternate, DINAlternate;
                font-weight: bold;
                font-size: 24px;
                color: #14cc76;
                line-height: 28px;
                text-align: left;
                font-style: normal;
              }
            }
          }
        }

        .count-bottom {
          width: 100%;
          display: flex;
          .bottom-content-orange {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            width: 25%;
            height: 170px;
            background: linear-gradient(
              180deg,
              rgba(20, 204, 118, 0.02) 0%,
              rgba(20, 204, 118, 0.06) 100%
            );
            border-radius: 4px;
            margin-top: 40px;
            margin-right: 38px;
            padding: 24px 10px 10px 24px;

            .bottom-word {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 18px;
              color: #313332;
              line-height: 22px;
              text-align: left;
              font-style: normal;
              margin-bottom: 16px;
              display: flex;
              align-items: center;
              .oranges-icon {
                margin-right: 12px;
              }
            }

            .count-icon {
              width: 100%;
              height: 100%;
              display: flex;
              margin-top: 12px;
              .orange-word {
                width: 100%;
                display: flex;
                justify-content: center;
                font-family: DINAlternate, DINAlternate;
                font-weight: bold;
                font-size: 24px;
                color: #14cc76;
                line-height: 28px;
                text-align: left;
                font-style: normal;
              }
            }
          }
        }
      }
    }

    .bottom-content {
      width: 100%;
      height: 55%;
      display: flex;
      flex-direction: column;

      .charts-block {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
<style lang="less" scoped>
/deep/ .ant-input {
  background: transparent;
  border: 1px solid #7c8496;
  // color: #4d94ff;
}
/deep/.ant-modal-content {
  width: 620px !important;
}

/deep/.ant-calendar-picker-input.ant-input {
  height: 40px !important;
}

/deep/.ant-spin-container {
  display: flex;
}

/deep/.ant-form {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
/deep/.ant-select-selection--single {
  height: 40px;
  width: 240px;
  display: flex;
  align-items: center;
  font-size: 16px;
}
</style>
